import styled from 'styled-components'
import supportsWebP from 'supports-webp'

import {
  useUpdateSessionUserParamMutation,
} from 'api/sessionUser'

import MainBackground4KWebp from 'assets/img/MainBG3840x2160.webp'
import MainBackground4KJpg from 'assets/img/MainBG3840x2160.jpg'
import MainBackground2KWebp from 'assets/img/MainBG2560x1440.webp'
import MainBackground2KJpg from 'assets/img/MainBG2560x1440.jpg'
import MainBackgroundFHDWebp from 'assets/img/MainBG1920x1080.webp'
import MainBackgroundFHDJpg from 'assets/img/MainBG1920x1080.jpg'

import RelayLogoUrl from 'assets/img/relay-brand.svg'
import Footer from 'components/App/Footer/Index'
import Icon from 'components/Shared/Icon/Index'

import colors from 'components/utils/colors'
import homePageTypes from 'constants/homePageTypes'

const StyledWrapper = styled.div`
  display: flex;
  flex: 1;
  @media (max-width: 1920px) {
    background-image: url(${supportsWebP ? MainBackgroundFHDWebp : MainBackgroundFHDJpg});
  }
  @media (min-width: 1921px) and (max-width: 2560px) {
    background-image: url(${supportsWebP ? MainBackground2KWebp : MainBackground2KJpg});
  }
  @media (min-width: 2561px) {
    background-image: url(${supportsWebP ? MainBackground4KWebp : MainBackground4KJpg});
  }
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

const StyledOverlay = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.35);
  justify-content: center;
  align-items: center;
`

const Dialog = styled.div`
  display: flex;
  width: 700px;
  height: 570px;
  flex-direction: column;
  border-radius: 3px;
  border: solid 1px #CAC9C9;
`

const DialogHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 240px;
  background-color: #FFF;
`

const DialogContent = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
`

const RelayLogo = styled.img`
  width: 24px;
`

const Title = styled.div`
  font-size: 36px;
  font-weight: 600;
  color: ${colors.secondary20};
  padding-top: 35px;
  padding-bottom: 10px;
`

const Subtitle = styled.div`
  font-size: 14px;
  letter-spacing: 0px;
  color: ${colors.secondary20};
  text-align: center;
`

const PageCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 250px;
  height: 230px;
  align-items: center;
  justify-content: flex-start;
  border-radius: 5px;
  border: solid 2px transparent;
  cursor: pointer;
  padding: 10px;
  box-sizing: border-box;
  transition: 0.3s;

  &:hover {
    border: solid 2px ${colors.primary40};
    background: #FFFFFF;
  }

`

const PageCardIcon = styled(Icon)`
  padding: 15px;

  ${PageCard}:hover & {
    &:before {
      color: ${colors.primary40};
    }
  }
`

const PageCardTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${colors.secondary40};
  padding-bottom: 10px;

  ${PageCard}:hover & {
    color: ${colors.secondary20};
  }
`

const PageCardText = styled.div`
  font-size: 14px;
  text-align: center;
  color: ${colors.secondary20};
  line-height: normal;
  opacity: 0;
  transition: 0.3s;

  ${PageCard}:hover & {
    opacity: 1;
  }
`

const SelectHomePage = () => {
  const [updateSessionUserParam] = useUpdateSessionUserParamMutation()

  const homePageSelect = (homePage) => {
    updateSessionUserParam({ homePage: homePage })
  }

  return (
    <StyledWrapper>
      <StyledOverlay>
        <Dialog data-test='select-home-page-dialog'>
          <DialogHeader>
            <RelayLogo src={RelayLogoUrl} />
            <Title data-test='select-home-page-title'>What would you like to do in Relay?</Title>
            <Subtitle data-test='select-home-page-subtitle'>
              This is just to get you started.
              You can always change your User Profile dashboard setting later.
            </Subtitle>
          </DialogHeader>
          <DialogContent>
            <PageCard data-test='select-home-page-card' onClick={() => homePageSelect(homePageTypes.TICKETS)}>
              <PageCardIcon iconName='icon-track-tickets' />
              <PageCardTitle>CREATE & TRACK TICKETS</PageCardTitle>
              <PageCardText>Submit and manage service management tickets</PageCardText>
            </PageCard>
            <PageCard data-test='select-home-page-card' onClick={() => homePageSelect(homePageTypes.STATS)}>
              <PageCardIcon iconName='icon-monitor-integration' />
              <PageCardTitle>MONITOR INTEGRATION</PageCardTitle>
              <PageCardText>Access statistics, analyze errors and track overall bonding health</PageCardText>
            </PageCard>
          </DialogContent>
        </Dialog>

        <Footer />
      </StyledOverlay>
    </StyledWrapper>
  )
}

export default SelectHomePage
